// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../types/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type BatchUpdateGraphVisualizationMutationVariables = Types.Exact<{
  input: Types.BatchUpdateGraphVisualizationInput;
}>;


export type BatchUpdateGraphVisualizationMutation = { __typename?: 'Mutation', batchUpdateGraphVisualization: { __typename?: 'BatchUpdateGraphVisualizationPayload', createdGroupIdMapping: Array<{ __typename?: 'GroupIdMapping', tempId: string, realId: string }> } };

export type BatchCreateEntityDiagramMutationVariables = Types.Exact<{
  input: Types.BatchCreateEntityDiagramInput;
}>;


export type BatchCreateEntityDiagramMutation = { __typename?: 'Mutation', batchCreateEntityDiagram: { __typename?: 'BatchCreateEntityDiagramPayload', entityDiagram: { __typename?: 'EntityDiagram', id: string }, createdGroupIdMapping: Array<{ __typename?: 'GroupIdMapping', tempId: string, realId: string }> } };

export const Operations = {
  Mutation: {
    BatchUpdateGraphVisualization: 'BatchUpdateGraphVisualization' as const,
    BatchCreateEntityDiagram: 'BatchCreateEntityDiagram' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}


export const BatchUpdateGraphVisualizationDocument = gql`
    mutation BatchUpdateGraphVisualization($input: BatchUpdateGraphVisualizationInput!) {
  batchUpdateGraphVisualization(input: $input) {
    createdGroupIdMapping {
      tempId
      realId
    }
  }
}
    `;
export type BatchUpdateGraphVisualizationMutationFn = Apollo.MutationFunction<BatchUpdateGraphVisualizationMutation, BatchUpdateGraphVisualizationMutationVariables>;

/**
 * __useBatchUpdateGraphVisualizationMutation__
 *
 * To run a mutation, you first call `useBatchUpdateGraphVisualizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBatchUpdateGraphVisualizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [batchUpdateGraphVisualizationMutation, { data, loading, error }] = useBatchUpdateGraphVisualizationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBatchUpdateGraphVisualizationMutation(baseOptions?: Apollo.MutationHookOptions<BatchUpdateGraphVisualizationMutation, BatchUpdateGraphVisualizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BatchUpdateGraphVisualizationMutation, BatchUpdateGraphVisualizationMutationVariables>(BatchUpdateGraphVisualizationDocument, options);
      }
export type BatchUpdateGraphVisualizationMutationHookResult = ReturnType<typeof useBatchUpdateGraphVisualizationMutation>;
export type BatchUpdateGraphVisualizationMutationResult = Apollo.MutationResult<BatchUpdateGraphVisualizationMutation>;
export type BatchUpdateGraphVisualizationMutationOptions = Apollo.BaseMutationOptions<BatchUpdateGraphVisualizationMutation, BatchUpdateGraphVisualizationMutationVariables>;
export const BatchCreateEntityDiagramDocument = gql`
    mutation BatchCreateEntityDiagram($input: BatchCreateEntityDiagramInput!) {
  batchCreateEntityDiagram(input: $input) {
    entityDiagram {
      id
    }
    createdGroupIdMapping {
      tempId
      realId
    }
  }
}
    `;
export type BatchCreateEntityDiagramMutationFn = Apollo.MutationFunction<BatchCreateEntityDiagramMutation, BatchCreateEntityDiagramMutationVariables>;

/**
 * __useBatchCreateEntityDiagramMutation__
 *
 * To run a mutation, you first call `useBatchCreateEntityDiagramMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBatchCreateEntityDiagramMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [batchCreateEntityDiagramMutation, { data, loading, error }] = useBatchCreateEntityDiagramMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBatchCreateEntityDiagramMutation(baseOptions?: Apollo.MutationHookOptions<BatchCreateEntityDiagramMutation, BatchCreateEntityDiagramMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BatchCreateEntityDiagramMutation, BatchCreateEntityDiagramMutationVariables>(BatchCreateEntityDiagramDocument, options);
      }
export type BatchCreateEntityDiagramMutationHookResult = ReturnType<typeof useBatchCreateEntityDiagramMutation>;
export type BatchCreateEntityDiagramMutationResult = Apollo.MutationResult<BatchCreateEntityDiagramMutation>;
export type BatchCreateEntityDiagramMutationOptions = Apollo.BaseMutationOptions<BatchCreateEntityDiagramMutation, BatchCreateEntityDiagramMutationVariables>;